import { Button, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IBankAccountViewModel, IPixAccountViewModel } from 'viewModels';
import { useEffect } from 'react';
import { Container, Content } from './styles';
import { BankAccountType, labelBankAccountType, labelPixType, PixType } from '../../../types/enums';
import { useBankAccounts } from '../../../context/bankAccounts';
import { toCpfMask } from '../../../utils/toCpfMask';
import { toCnpjMask } from '../../../utils/toCnpjMask';

interface ICardAccountsProps {
  bankAccountSelected?: IBankAccountViewModel;
  pixAccountSelected?: IPixAccountViewModel;
  type: 'bank' | 'pix';
}

export function CardAccounts({
  bankAccountSelected,
  pixAccountSelected,
  type,
}: ICardAccountsProps) {
  const { returnNameBank } = useBankAccounts();

  useEffect(() => {
    if (type === 'bank' && bankAccountSelected?.bank && !bankAccountSelected?.nameBank) {
      // eslint-disable-next-line no-param-reassign
      bankAccountSelected.nameBank = returnNameBank(bankAccountSelected.bank);
    }
  }, [bankAccountSelected, returnNameBank, type]);

  const getDocumentType = (document?: string) => {
    if (!document) return '';
    const cleanedDocument = document.replace(/\D/g, '');
    return cleanedDocument.length === 11 ? 'CPF' : 'CNPJ';
  };

  return (
    <Container>
      {type === 'bank' ? (
        <Content>
          <div className="icon-copy">
            <Tooltip disableInteractive title="Copiar" placement="top" arrow>
              <Button
                className="button-copy"
                onClick={() => {
                  const dataClipboard = `Banco: ${bankAccountSelected?.nameBank}${'\n'}Agência: ${
                    bankAccountSelected?.agency
                  }${'\n'}Conta: ${bankAccountSelected?.accountNumber}${'\n'}${getDocumentType(
                    bankAccountSelected?.document,
                  )}: ${bankAccountSelected?.document} ${'\n'}Nome Titular: ${
                    bankAccountSelected?.holderName
                  }${'\n'}Tipo da Conta: ${
                    labelBankAccountType[bankAccountSelected?.type as BankAccountType]
                  }${'\n'}`;
                  navigator.clipboard.writeText(dataClipboard);
                }}>
                <ContentCopyIcon />
              </Button>
            </Tooltip>
          </div>
          <div className="cnt-card">
            <div className="cardItem">
              Banco
              <span>
                {bankAccountSelected?.bank} - {bankAccountSelected?.nameBank}
              </span>
            </div>
            <div className="cardAccount-data">
              <div className="cardItem">
                Agência
                <span>{bankAccountSelected?.agency}</span>
              </div>
              <div className="cardItem">
                Conta
                <span>{bankAccountSelected?.accountNumber}</span>
              </div>
            </div>
            <div className="cardItem">
              Nome Titular
              <span>{bankAccountSelected?.holderName}</span>
            </div>
            <div className="cardItem">
              {getDocumentType(bankAccountSelected?.document)}
              <span>{bankAccountSelected?.document}</span>
            </div>
            {bankAccountSelected?.type !== undefined && (
              <div className="cardItem">
                Tipo da Conta
                <span>{labelBankAccountType[bankAccountSelected?.type as BankAccountType]}</span>
              </div>
            )}
          </div>
        </Content>
      ) : (
        <Content>
          <div className="icon-copy">
            <Tooltip disableInteractive title="Copiar" placement="top" arrow>
              <Button
                className="button-copy"
                onClick={() => {
                  const dataClipboard = `${pixAccountSelected?.key}`;
                  navigator.clipboard.writeText(dataClipboard);
                }}>
                <ContentCopyIcon />
              </Button>
            </Tooltip>
          </div>

          <div className="cnt-card">
            <div className="cardItem">
              Chave Pix
              <span className="pixKey">{pixAccountSelected?.key}</span>
            </div>
            <div className="cardItem">
              Tipo de chave
              {Object.keys(PixType)
                .filter((key) => Number(key) === pixAccountSelected?.type)
                .map((key) => (
                  <span className="pixType" key={key}>
                    {labelPixType[key as unknown as PixType]}
                  </span>
                ))}
            </div>
            {pixAccountSelected?.holderName && (
              <div className="cardItem">
                Nome
                <span>{pixAccountSelected?.holderName}</span>
              </div>
            )}
            {pixAccountSelected?.holderDocument && (
              <div className="cardItem">
                {getDocumentType(pixAccountSelected?.holderDocument)}
                <span>
                  {pixAccountSelected?.holderDocument?.length === 11
                    ? toCpfMask(pixAccountSelected?.holderDocument)
                    : toCnpjMask(pixAccountSelected?.holderDocument)}
                </span>
              </div>
            )}
          </div>
        </Content>
      )}
    </Container>
  );
}
